import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { VisualsService } from '@core/Abstract/visuals.service';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: any[];
  public genericVisuals:any = {};

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private logger: LogService,
    private eventsEmitterService: EventsEmitterService,
    private securityService: SecurityService,
    protected visualsService: VisualsService
  ) {    
    this.eventsEmitterService.languageChange.subscribe(
      langId => {
        this.Menus();
        this.getVisuals();
      }
    )
  }
  private Menus() {
    this.sidebarnavItems = this.visualsService.getFromStorageAsJSON('menusArray');
  }

  protected getVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
  }

  // End open close
  ngOnInit() {
    this.Menus();
    this.getVisuals();
  }
}
